import { ContainerModule } from 'inversify';

import 'reflect-metadata';

const infrastructureModule = new ContainerModule(() => null);

export default infrastructureModule;
